export default { // 权限控制
  get_menuRole: './userInfo/queryMenu', // 查询用户菜单
  get_menuRoleCommon: './erpCommon/setting-service/userInfo/queryMenu' // 查询用户菜单
};
